import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container, Box, Typography, Button, TextField, Alert, Divider, CircularProgress } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import authConfig from '../../config/auth';
import { emailLogin } from '../../actions/authActions';

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(searchParams.get('error') || '');
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleGoogleLogin = () => {
    setGoogleLoading(true);
    const params = new URLSearchParams({
      client_id: authConfig.clientId,
      redirect_uri: authConfig.callbackUrl,
      idp: 'GoogleWorkspace',
    });
    window.location.href = `${authConfig.ttsAuthUrl}/api/v1/auth/login?${params}`;
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await dispatch(emailLogin({ email, password }));
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img
          src="/img/top-ts-logo.jpg"
          alt="The Tapping Solution"
          style={{ width: 200, marginBottom: 24 }}
        />
        <Typography component="h1" variant="h5" gutterBottom>
          CMS Admin Login
        </Typography>

        {error && !showEmailLogin && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>
        )}

        <Button
          fullWidth
          variant="contained"
          startIcon={googleLoading ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
          onClick={handleGoogleLogin}
          disabled={googleLoading}
          sx={{ mt: 2, mb: 2, py: 1.5 }}
        >
          {googleLoading ? 'Redirecting...' : 'Sign in with Google'}
        </Button>

        {!showEmailLogin && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ cursor: 'pointer', textDecoration: 'underline', mt: 1 }}
            onClick={() => setShowEmailLogin(true)}
          >
            Sign in with email instead
          </Typography>
        )}

        {showEmailLogin && (
          <>
            <Divider sx={{ width: '100%', my: 2 }}>or</Divider>
            {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
            <Box component="form" onSubmit={handleEmailLogin} sx={{ width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Email Address"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                label="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button type="submit" fullWidth variant="outlined" sx={{ mt: 2 }}>
                Sign In
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Container>
  );
}

export default Login;
